import { setLanguage } from '@/utils/languageSync';
import { patchPreferredLocale } from '@/apis/user';
import { useAuthStore } from '@/store/useAuthStore';

/**
 * Switch UI language and persist preferred_locale for the logged-in user.
 * @param {'fr'|'en'} locale
 */
export function persistPreferredLocale(locale) {
  setLanguage(locale);

  const { user, sessionHydrated, impersonating, setProfile } = useAuthStore.getState();
  if (!sessionHydrated || !user?.id || impersonating) {
    return;
  }

  patchPreferredLocale(locale)
    .then((res) => {
      if (res?.code === 200 && res?.data?.user) {
        setProfile({ ...user, ...res.data.user });
      } else {
        setProfile({ ...user, preferred_locale: locale });
      }
    })
    .catch((err) => {
      console.error('[persistPreferredLocale] patch failed:', err);
    });
}
